import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sizeFile',
    standalone: true
})
export class SizeFilePipe implements PipeTransform {
    transform(value: number, unit: string = 'MB'): string {
        if (unit === 'KB') {
            return (value / 1024).toFixed(2) + ' KB';
        } else if (unit === 'MB') {
            return (value / (1024 * 1024)).toFixed(2) + ' MB';
        } else {
            return value.toString() + ' B';
        }
    }
}
